import React from 'react'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'

export interface CommonWebsiteLayoutBodyProps {
  header: React.ReactNode
  content?: React.ReactNode
  footer: React.ReactNode
}

export const CommonWebsiteLayoutBody = ({
  header,
  content,
  footer,
}: CommonWebsiteLayoutBodyProps) => {
  const { t } = useTypedTranslation()

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      {header}
      <main>
        {content ?? (
          <div
            style={{
              minHeight: '640px',
              width: '100%',
              backgroundColor: 'fff',
            }}
          >
            {t('components.website_layout_body.content_placeholder')}
          </div>
        )}
      </main>
      {footer}
    </div>
  )
}
